module.exports = __webpack_public_path__ + "img/gaizao2.b50d0640.png";